/**
 * 初始建议重量（§12.3 / §15 明确给出的起步值）。
 *
 * 仅收录规格中**明确给出**的起步重量；其余动作首次执行进入「校准」
 * （无历史时不给出虚假建议，建议重量为 null，表示首次校准）。
 * 哑铃一律标注「每只」口径；器械用「器械显示值」口径（决策 14.15）。
 *
 * 有历史重量时（调用方传入 lastWeights），以历史为准覆盖本表。
 */

import type { WeightUnitScope } from "@jilian/shared";

export interface StartingWeight {
  weightKg: number;
  weightUnitScope: WeightUnitScope;
}

export const STARTING_WEIGHTS: Readonly<Record<string, StartingWeight>> = {
  // §12.3：平板哑铃卧推 每只 10 kg
  flat_dumbbell_press: { weightKg: 10, weightUnitScope: "per_dumbbell" },
  // §12.3：上斜哑铃卧推 每只 7.5 kg
  incline_dumbbell_press: { weightKg: 7.5, weightUnitScope: "per_dumbbell" },
  // §12.3：高位下拉 30 kg（器械显示值）
  wide_grip_lat_pulldown: { weightKg: 30, weightUnitScope: "machine_display" },

  // 经典杠铃动作起步重量
  barbell_bench_press: { weightKg: 40, weightUnitScope: "total" },
  incline_barbell_press: { weightKg: 30, weightUnitScope: "total" },
  barbell_overhead_press: { weightKg: 25, weightUnitScope: "total" },
  barbell_row: { weightKg: 30, weightUnitScope: "total" },
  barbell_biceps_curl: { weightKg: 15, weightUnitScope: "total" },
  skull_crusher: { weightKg: 15, weightUnitScope: "total" },
  hip_thrust: { weightKg: 40, weightUnitScope: "total" },
};

/** 取初始建议（无则 null = 首次校准）。 */
export function startingWeightFor(exerciseId: string): StartingWeight | null {
  return STARTING_WEIGHTS[exerciseId] ?? null;
}